import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import InputLabel from '../input-label/InputLabel';
import './CheckboxInput.css';

export default class CheckboxInput extends Component {
  // Create new prop for old and new checkbox. Prop would take a string, and then component would check the value of the sting and use the right version
  constructor(props) {
    super(props);

    this.state = {
      isChecked: this.props.checked
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ('checked' in newProps && newProps.checked !== this.state.isChecked) {
      this.setState({ isChecked: newProps.checked });
    }
  }

  onChange = (e) => {
    this.setState((prevState) => {
      return { isChecked: !prevState.isChecked }
    }, () => {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    });
  }

  getValue = () => {
    if (this.props.required && !this.state.isChecked) {
      throw new InputError(this.props.label + " is Required", this.state.isChecked);
    }

    return this.state.isChecked;
  }

  render() {
    let checkbox = (
      <input
        id={this.props.id}
        className={this.props.className}
        type="checkbox"
        name={this.props.name}
        value={this.props.value}
        onChange={(e) => {
          e.persist();
          this.onChange(e);
        }}
        required={this.props.required}
        disabled={this.props.disabled}
        checked={this.state.isChecked}
      />
    );

    let legend = (this.props.legend) ?
      <label className="legend" htmlFor={this.props.id}>
        {this.props.legend}
      </label> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    const checkboxWrapperClassNames = this.props.checkboxWrapperClassName;

    if (!this.props.isEditable) {
      let checkedContent = (this.props.checked) ?
        this.props.label :
        null;


      return (
        <div className={`${verticalSpacingClass} ${checkboxWrapperClassNames}`}>
          {legend}
          <div className="read-only">
            {checkedContent}
          </div>
        </div>
      )
    }
    else {
      return (
        <div heap-ignore='true' className={`${verticalSpacingClass} ${checkboxWrapperClassNames}`}>
          {legend}
          {checkbox}
          <InputLabel
            label={this.props.label}
            htmlFor={this.props.id}
            isEditable={this.props.isEditable}
            required={this.props.required}
            requiredFieldIndicatorStyle={this.props.requiredFieldIndicatorStyle}
          />
          {errorMessage}
        </div>
      );
    }
  }
}

CheckboxInput.defaultProps = {
  checked: false,
  checkboxWrapperClassName: "",
  isEditable: true,
  required: false,
  requiredFieldIndicatorStyle: {style: "star", position: "before"}
};

CheckboxInput.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  checkboxWrapperClassName: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  legend: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  requiredFieldIndicatorStyle: PropTypes.shape({
    style: PropTypes.string,      // either "star", "dot" or "none"
    position: PropTypes.string    // either "before" or "after"
  }),
  value: PropTypes.string,
  verticalSpacing: PropTypes.string
}
